import {http} from '@/axios'
import router from '@/router'
import store from '../index'

function getInitState() {
  return {
    pending_restaurants: false,
    loaded_restaurants: false,
    promise_restaurants: null,
    categories: [],
    restaurants: [],
    all_restaurants: [],
    active_restaurant: null
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  getters: {},
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(store, [key, value]) {
      store[key] = value
    }
  },
  actions: {
    load({state, commit, dispatch}) {
      if (state.loaded_restaurants) return Promise.resolve()

      if (state.pending_restaurants) {
        return state.promise_restaurants
      }

      commit('setProperty', ['pending_restaurants', true])

      const promiseRestaurants = http.get(`api/restaurant/restaurants`)
        .then(({data}) => {
          commit('setProperty', ['categories', data.data.categories])
          commit('setProperty', ['restaurants', data.data.restaurants])
          commit('setProperty', ['all_restaurants', getAllRestaurants(data.data.categories, data.data.restaurants)])
          if (router.currentRoute.params.restaurantId) {
            dispatch('setActiveRestaurant', router.currentRoute.params.restaurantId)
          } else {
            dispatch('setActiveRestaurant', getActiveRestaurantIdFromLocalStorage())
          }
        })
        .finally(() => {
          commit('setProperty', ['loaded_restaurants', true])
          commit('setProperty', ['pending_restaurants', false])
          commit('setProperty', ['promise_restaurants', false])
        })

      commit('setProperty', ['promise_restaurants', promiseRestaurants])

      return promiseRestaurants
    },
    setActiveRestaurant({commit, state}, id) {
      let oldId = getActiveRestaurantIdFromLocalStorage()
      let availableRestaurants = state.all_restaurants.filter(item => item.online_delivery)
      let activeRestaurant = null
      if (id) {
        activeRestaurant = availableRestaurants.find(item => item.id == id) || null
      }

      if (activeRestaurant) {
        commit('setProperty', ['active_restaurant', activeRestaurant])
        return Promise.resolve(setActiveRestaurantIdToLocalStorage(activeRestaurant.id))
      }

      if (oldId || oldId != id) {
        activeRestaurant = availableRestaurants.find(item => item.id == oldId) || null
        commit('setProperty', ['active_restaurant', activeRestaurant])
        return Promise.resolve(setActiveRestaurantIdToLocalStorage(oldId))
      } else {
        commit('setProperty', ['active_restaurant', availableRestaurants[0]])
        return Promise.resolve(setActiveRestaurantIdToLocalStorage(availableRestaurants[0].id))
      }
    }
  }
}

function getAllRestaurants(categories, restaurants) {
  const restaurantsInCategories = categories.reduce((arr, category) => {
    const newCategory = {
      id: category.id,
      slug: category.slug,
      name: category.name
    }

    const catRestaurants = category.restaurants.map(restaurant => {
      return {
        ...restaurant,
        category: newCategory
      }
    })

    return arr.concat(catRestaurants)
  }, [])

  return restaurantsInCategories.concat(restaurants)
}

function getActiveRestaurantIdFromLocalStorage() {
  return window.localStorage.getItem('active_restaurant_id') || null
}

function setActiveRestaurantIdToLocalStorage(id) {
  if (!id) return
  let old = getActiveRestaurantIdFromLocalStorage()
  if (old != id) {
    window.localStorage.setItem('active_restaurant_id', id)
    store.dispatch('basket/loadBasket')
  }
  return id
}
